/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import useUserStore from '../../../store/userStore/userStore';

export interface AskAIResponse {
    query_key: string;
    refined_query: string;
    response: string;
    session_id: string;
    response_time: number;
    debug_info: boolean | null
}

export const askAIPrompt = async (
  userId: string,
  companyId: string,
  queryKey: string
): Promise<AskAIResponse | undefined> => {
  const token = useUserStore.getState().userToken;

  try {
    const askAIBody = {
      user_id: userId,
      company_id: companyId,
      query_key: queryKey,
      debug_info: false
    };
    const response = await axios.request({
      method: 'post',
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.askAI}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      timeout: 60000 * 5, // 60 seconds * 3
      params: {},
      data: askAIBody ?? {}
    });

    return response.data;
  } catch (err) {
    console.log('err:', err);
  }
};
